<template>
  <div style="margin-top: 60px" class="home">
    <strong>{{ message }}</strong>
    <Loader :dialog-loader="dialogLoader" :message="message"></Loader>
  </div>
</template>
<script>
import {
  getSetOfPayments,
  updatePayment,
  getNextSetOfPayments
} from "@/collections/payments";
import moment from "moment";
import Loader from "@/components/common/Loader";
export default {
  name: "UpdatePaymentNumber",
  components: {
    Loader
  },
  data() {
    return {
      dialogLoader: true
    };
  },
  created() {
    this.updatePaymentsCollection();
  },
  computed: {
    message() {
      return this.dialogLoader
        ? this.$t("cart.updatePaymentsCollection")
        : this.$t("cart.updated");
    }
  },
  methods: {
    async updatePaymentsCollection() {
      try {
        let first = await getSetOfPayments();
        let paymentByDate = {};
        while (!first.empty || first.exists) {
          let payments = [];
          first.forEach(doc => {
            let payment = doc.data();
            payment.id = doc.id;
            payments.push(payment);
          });
          payments = payments.map(x => ({
            ...x,
            payment_date: moment(x.payment_on.seconds * 1000).format(
              "DD-MM-YYYY"
            )
          }));

          payments.forEach(payment => {
            paymentByDate[payment.payment_date] // check if that array exists or not in paymentByDate object
              ? paymentByDate[payment.payment_date].push(payment) // just push
              : ((paymentByDate[payment.payment_date] = []),
                paymentByDate[payment.payment_date].push(payment)); // create a new array and push
          });

          let last = first.docs[first.docs.length - 1];
          first = await getNextSetOfPayments(last);
          console.log("nextSet", last);
        }
        console.log("paymentByDate1", paymentByDate);
        this.updatePaymentNumber(paymentByDate);
      } catch (error) {
        this.setlogError(
          "get_next_set_of_payments/set_of_payments",
          "Obtained error message in updatePaymentsCollection()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updatePaymentNumber(payments) {
      if (Object.keys(payments).length <= 0) {
        return;
      }
      let number = 0;
      let now = moment().format();
      // eslint-disable-next-line no-unused-vars
      for (const [date, payments] of Object.entries(payments)) {
        payments.forEach(async payment => {
          number++;
          payment.number = number;
          console.log("paymentNumber", date, payment.number);
          let obj = {
            number: number,
            updated_on: now
          };
          await updatePayment(payment.id, obj).catch(error => {
            this.setlogError(
              "update_payment",
              "Obtained error message in updatePaymentNumber()",
              error.stack,
              this.$options.name
            );
          });
        });
      }
      this.dialogLoader = false;
    }
  }
};
</script>
